<script>
    import {_, number, locale} from 'svelte-i18n';
    import Item from './Item.svelte';
    import {gameConfig} from "../../stores.js";
    import {NAVAL_ICONS, doubloonKeys, doubloonValue, resolveTitle} from './naval-items.js';

    let { item, gameItem } = $props();
    let itemDetails = $state({});

    function setItemDetails() {
        const keys = doubloonKeys();
        // Per-item payload. Never gameItem.goldValue — see doubloonValue (SC-4547).
        const points = doubloonValue(gameItem);

        itemDetails.title = resolveTitle({
            key: keys.title,
            fallback: 'Doubloons',
            translate: (k) => $_(k, {values: {POINTS: $number(points)}}),
        });
        itemDetails.description = resolveTitle({
            key: keys.description,
            fallback: '',
            translate: (k) => $_(k, {values: {POINTS: $number(points)}}),
        });
        itemDetails.amount = item.amount;
        itemDetails.icon = NAVAL_ICONS.doubloons;
        itemDetails.rarity = gameItem.rarity;
        itemDetails.expireAt = $gameConfig?.temporaryItems?.[item.id];
        itemDetails.claimed = item.claimed;
    }

    $effect(() => {
        $locale;
        setItemDetails();
    });
</script>

<Item {itemDetails}/>
